window.Products.Clothing.KangarooHoodie = function() {
};
window.Products.Clothing.KangarooHoodie.inherits(window.Products.Clothing.Shirt);
window.Products.Clothing.KangarooHoodie.dpi = 150;
window.Products.Clothing.KangarooHoodie.has_3d = true;
window.Products.Clothing.KangarooHoodie.id = 96;
window.Products.Clothing.KangarooHoodie.slug = 'kangaroo-hoodie';
window.Products.Clothing.KangarooHoodie.syncColors = true;
window.Products.Clothing.KangarooHoodie.texturesLoaded = 0;
window.Products.Clothing.KangarooHoodie.texturesLoading = false;
window.Products.Clothing.KangarooHoodie.use_glb = true;

window.Products.Clothing.KangarooHoodie.prototype.outsideObject = 3;
window.Products.Clothing.KangarooHoodie.prototype.insideObject = 1;
window.Products.Clothing.KangarooHoodie.prototype.detailsObject = 0;

window.Products.Clothing.KangarooHoodie.prototype.handleColorOption = function(modelViewer, color){
	var me = modelViewer.product;

	var object = modelViewer.object;
	if(!object) return;

	if(!color) {
		if(modelViewer.inlab){
			$('#button_options_color').find('img').attr('src', $(this).find('img').attr('src'));
			$('#container_options_color, #button_options_color').removeClass('active');
			color = $(this).attr('for');
		} else {
			color = $('#productInfo-productOption-color').find('option:selected').attr('data-slug');
		}
	}

	var three_color = me.getColor(color);

	object.children[me.detailsObject].material.color = three_color;
	object.children[me.insideObject].material.color = three_color;

	me.updateThreeTexture(modelViewer);

	object.children[me.outsideObject].material.aoMapIntensity = 1;
	object.children[me.insideObject].material.aoMapIntensity = 1;
};

window.Products.Clothing.KangarooHoodie.prototype.getColor = function(_name){
	colors = {
		"white": 0xffffff,
		"black": 0x151515,
		"dark_heather": 0x3f3d47,
		"maroon": 0x6c1e34,
		"navy_blue": 0x262738,
		"sport_grey": 0xa6a3a8
	};

	return new THREE.Color(colors[_name]);
};